module.exports = __webpack_public_path__ + "static/case-study-31abbfbef0322e4f9323db57205900ab.svg";